import React from "react";
import { cn } from "../../utils/cn";
import logo from "../../assets/loyalbase-logo.svg";
import logoWhite from "../../assets/loyalbase-logo-white.svg";

// Swaps on the `dark` class the Navbar toggle sets on <html>, not the OS preference.
const BrandLogo = ({ className, alt = "LoyalBase" }) => (
  <>
    <img src={logo} alt={alt} className={cn(className, "dark:hidden")} />
    <img src={logoWhite} alt={alt} className={cn(className, "hidden dark:block")} />
  </>
);

export default BrandLogo;
